"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageProvider = exports.LanguageContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../sfra-api/contexts");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LanguageContext = exports.LanguageContext = /*#__PURE__*/_react.default.createContext({});
const LanguageProvider = ({
  locale,
  children
}) => {
  const SFRAClient = (0, _contexts.useCommerceSFRAAPI)();
  locale = locale.replace(/-/g, '_');
  const [i18n, setI18n] = (0, _react.useState)({
    locale: locale,
    currentCountry: {
      country: '',
      code: '',
      lang: '',
      config: {}
    },
    countries: [],
    error: null
  });
  (0, _react.useEffect)(() => {
    // @ts-ignore
    SFRAClient.Site.getLocales().then(({
      countries
    }) => {
      var _locale, _selectedLang$name;
      const selectedCountry = countries === null || countries === void 0 ? void 0 : countries.find(country => country.locales.find(lang => lang.locale === locale));
      const selectedLang = (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.locales.find(lang => lang.locale === locale)) || {};
      setI18n({
        locale: locale,
        countries,
        currentCountry: {
          country: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryName) || '',
          code: ((_locale = locale) === null || _locale === void 0 ? void 0 : _locale.split('_')[1]) || '',
          lang: (selectedLang === null || selectedLang === void 0 ? void 0 : (_selectedLang$name = selectedLang.name) === null || _selectedLang$name === void 0 ? void 0 : _selectedLang$name.split(' ')[0]) || '',
          config: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.config) || {}
        }
      });
    }).catch(err => {
      setI18n(err);
    });
  }, [locale]);
  return /*#__PURE__*/_react.default.createElement(LanguageContext.Provider, {
    value: i18n
  }, children);
};
exports.LanguageProvider = LanguageProvider;